import * as React from 'react';
import { useSelector } from 'react-redux';
import { ECurrentErrorField } from '../../../../actions/filters/types';
import { trackRoomsCountClick } from '../../../../analytics';
import { selectFilters } from '../../../../selectors';
import { useActions } from '../useActions';
import { roomsCountSelectorOptions } from '../../../../constants';
/** Пропсы для фильтра выбора комнатности */

export var useRoomsCountSelectorProps = function useRoomsCountSelectorProps() {
  var _useSelector = useSelector(selectFilters),
      roomsCount = _useSelector.roomsCount,
      errorTooltip = _useSelector.errorTooltip,
      userSetArea = _useSelector.userSetArea,
      flatAreas = _useSelector.flatAreasSuggest.flatAreas,
      estimationTarget = _useSelector.estimationTarget;

  var _useActions = useActions(),
      setRooms = _useActions.setRooms,
      setError = _useActions.setError,
      setArea = _useActions.setArea;

  var errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.roomsCount ? errorTooltip.errorText : '';
  var onValueChange = React.useCallback(function (value) {
    setRooms({
      roomsCount: value
    });
    trackRoomsCountClick(estimationTarget);

    if (errorMessage) {
      setError({
        currentErrorField: ECurrentErrorField.roomsCount,
        errorText: ''
      });
    }

    if (flatAreas) {
      var areaFound = flatAreas.find(function (item) {
        return item.roomsCount === value;
      });

      if (areaFound && !userSetArea) {
        setArea({
          area: areaFound.area
        });
      }
    }
  }, [errorMessage, flatAreas, setArea, setError, setRooms, userSetArea, estimationTarget]);
  return {
    value: roomsCount || NaN,
    onValueChange: onValueChange,
    errorMessage: errorMessage,
    values: roomsCountSelectorOptions,
    placeholder: 'Комнат *'
  };
};